const styles = ({
  palette,
  palette: {
    grey,
    text: { dark, light }
  },
  spacing: { unit },
  typography: { fontWeightHeavy }
}) => ({
  paymentType: {
    color: dark,
    fontSize: `${unit * 1.75}px`,
    margin: '0px',
    '& p:first-child': {
      color: grey.G600,
      fontSize: `${unit * 1.5}px`,
      fontWeight: fontWeightHeavy,
      marginBottom: `${unit}px`,
      textTransform: 'uppercase'
    }
  }
});

export default styles;
